// src/components/HostIcons.jsx
import React, { useState, useCallback } from 'react';

export function HostIcons({ hostList, hostsWithTodayIncome = [], onHostClick }) {
  const [touchedCard, setTouchedCard] = useState(null);

  // User avatar colors for variety
  const avatarColors = [
    '#6366f1', '#8b5cf6', '#06b6d4', '#10b981', '#f59e0b',
    '#ef4444', '#ec4899', '#84cc16', '#f97316', '#3b82f6',
    '#14b8a6', '#f43f5e', '#a855f7', '#22c55e', '#eab308',
    '#dc2626', '#db2777', '#65a30d', '#ea580c', '#2563eb'
  ];

  // 해당 호스트가 오늘 수입이 있는지 확인하는 함수
  const hasIncomeToday = (hostName) => {
    return hostsWithTodayIncome.includes(hostName);
  };

  // 햅틱 피드백 함수
  const triggerHapticFeedback = useCallback(() => {
    if (navigator.vibrate) {
      navigator.vibrate(50); // 50ms 진동
    }
  }, []);

  // 터치 시작 이벤트
  const handleTouchStart = useCallback((hostName) => {
    setTouchedCard(hostName);
    triggerHapticFeedback();
  }, [triggerHapticFeedback]);

  // 터치 종료 이벤트
  const handleTouchEnd = useCallback(() => {
    setTouchedCard(null);
  }, []);

  // 클릭 핸들러
  const handleCardClick = useCallback((hostName) => {
    triggerHapticFeedback();
    onHostClick(hostName);
  }, [onHostClick, triggerHapticFeedback]);

  // 키보드 이벤트 핸들러 (접근성)
  const handleKeyDown = useCallback((event, hostName) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleCardClick(hostName);
    }
  }, [handleCardClick]);

  return (
    <div className="host-icons-grid">
      {hostList && hostList.map((hostName, index) => (
        <div 
          className={`host-card ${touchedCard === hostName ? 'touched' : ''}`} 
          key={hostName}
        >
          <div 
            className="host-card-inner"
            onClick={() => handleCardClick(hostName)}
            onTouchStart={() => handleTouchStart(hostName)}
            onTouchEnd={handleTouchEnd}
            onKeyDown={(e) => handleKeyDown(e, hostName)}
            tabIndex={0}
            role="button"
            aria-label={`${hostName} 호스트 선택 - ${hasIncomeToday(hostName) ? '온라인' : '오프라인'}`}
          >
            <div className="host-icon-wrapper">
              <div 
                className="host-avatar-icon"
                style={{ 
                  backgroundColor: avatarColors[index % avatarColors.length],
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '100%',
                  height: '100%',
                  transition: 'all 0.3s ease'
                }}
              >
                <i 
                  className="fas fa-user" 
                  style={{ 
                    fontSize: '2rem', 
                    color: 'white',
                    textShadow: '0 2px 4px rgba(0, 0, 0, 0.3)'
                  }}
                  aria-hidden="true"
                ></i>
              </div>
              <div className="host-overlay">
                <i className="fas fa-play host-play-icon" aria-hidden="true"></i>
              </div>
            </div>
            <div className="host-info">
              <div className="host-name">
                <i className="fas fa-desktop me-2" aria-hidden="true"></i>
                {hostName}
              </div>
              <div className={`host-status ${hasIncomeToday(hostName) ? 'online' : 'offline'}`}>
                <span 
                  className={`status-indicator ${hasIncomeToday(hostName) ? 'online' : 'offline'}`}
                  aria-hidden="true"
                ></span>
                {hasIncomeToday(hostName) ? '온라인' : '오프라인'}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
